// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  height: 93%;
  width: 205px;
  top: 80px;
  left: 0px;
  position: fixed;
  z-index: 1;
  background-color: #00A19B;
  overflow-x: hidden;
  border-radius: 0px;
  overflow: auto;
  padding-bottom: 10px;
  overflow: visible;
}




.sidebar-tab {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-bottom: 2px solid rgb(255 255 255 / 14%);
  width: 80%;
  margin: 0 auto;
  padding-bottom: 20px;
  opacity: 0.5;
}

.sidebar-tab:last-child {
  border-bottom: unset;
}

.sidebar-tab:hover {
  opacity: 1;
}

.sidebar-tab.active{
  opacity: 1;
}

.sidebar-tab-wallet,
.sidebar-tab-wallet-2 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-bottom: 2px solid rgb(56 56 56 / 14%);
  /* width: 80%; */
  background-color: #fbc425;
  margin: 0 auto;
  padding-bottom: 16px;
}

.sidebar-tab-icon img {
  width: 52px;
  height: 52px;
  cursor: pointer;
}

.sidebar-tab-wallet p {
  font-size: 20px;
  margin: 0px;
  padding-top: 6px;
  cursor: pointer;
}

.sidebar-tab-wallet-2 p {
  font-size: 20px;
  margin: 0px;
  color: #fff;
  padding-top: 6px;
  cursor: pointer;
}

.sidebar-tab p {
  font-size: 18px;
  color: #fff;
  margin: 0px;
  padding-top: 0px;
  cursor: pointer;
}

.sidebar-tab-icon {
  margin-top: 10px;
}

.sidebar-wrapper {
  margin-top: 20px;
}

.sidebar-tab-active {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-bottom: 2px solid rgb(255 255 255 / 14%);
  width: 80%;
  margin: 0 auto;
  padding-bottom: 16px;
}

.sidebar-tab-active p {
  font-size: 20px;
  color: #fbc425;
  margin: 0px;
  padding-top: 6px;
}

.sidebar-tab-logout {
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-top: 50px; */
  gap: 0px;
  opacity: 1;
}

.sidebar-tab-logout:hover{
  opacity: 1;
}

.sidebar-tab-logout .sidebar-tab-icon {
  margin-top: 6px;  
}

.sidebar-tab-logout p {
  font-size: 20px;
  color: #fff;
  margin: 0px;
  padding-top: 10px;
  cursor: pointer;
}


.sidebar-tab button#dropdown-button-drop-end {
  background: none;
  border: none;
  position: absolute;
  top: 10px;
  right: -90px;
  font-size: 30px;
  width: 160px;
  text-align: right;
  height: 80px;
}

.sidebar-tab .dropdown-menu.show {
  background: #00A19B;
  border: none;
  border-radius: 0px;
  opacity: 1;
  transform: translate(105px, 0px) !important;
  width: 230px;
}

.sidebar-tab a.dropdown-item {
  font-size: 20px;
  color: #fff;
  opacity: 0.5;
  border-bottom: 1px solid #fff;
  border-radius: 0px;
  padding: 10px 40px;
}

.sidebar-tab a.dropdown-item:hover{
  opacity: 1;
}

.sidebar-tab a.dropdown-item:hover:first-child{
  opacity: 0.5;
}

.sidebar-tab a.dropdown-item:first-child{
  font-size: 26px;
}

.sidebar-tab a.dropdown-item:last-child{
  border-bottom: none;
}





@media (min-width: 768px) and (max-width: 1599px) {
  .sidebar-wrapper {
    margin-top: 20px;
    height: calc(100vh - 100px);
    overflow-y: auto;
    overflow-x: visible
  }

  .sidebar.dropdown-active .sidebar-wrapper{
    overflow: visible;
  }

  .sidebar {
    height: 90%;
    width: 185px;
    top: 70px;
  }

  .sidebar-tab-icon img {
    width: 46px;
    height: 46px;
  }

  .sidebar-tab p {
    font-size: 16px;
  }

  .sidebar-tab a.dropdown-item:first-child {
    font-size: 22px;
  }

  .sidebar-tab a.dropdown-item {
    font-size: 18px;
  }

  .sidebar-tab .dropdown-menu.show {
    transform: translate(99px, 0px) !important;
    width: 200px;
  }
}

@media (max-width: 768px) {
  .sidebar {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,SAAS;EACT,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;;;;AAKA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C;EAC/C,UAAU;EACV,cAAc;EACd,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C;EAC/C,UAAU;EACV,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;;AAGA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;;;;;AAMA;EACE;IACE,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;IAChB;EACF;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0CAA0C;IAC1C,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".sidebar {\n  height: 93%;\n  width: 205px;\n  top: 80px;\n  left: 0px;\n  position: fixed;\n  z-index: 1;\n  background-color: #00A19B;\n  overflow-x: hidden;\n  border-radius: 0px;\n  overflow: auto;\n  padding-bottom: 10px;\n  overflow: visible;\n}\n\n\n\n\n.sidebar-tab {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border-bottom: 2px solid rgb(255 255 255 / 14%);\n  width: 80%;\n  margin: 0 auto;\n  padding-bottom: 20px;\n  opacity: 0.5;\n}\n\n.sidebar-tab:last-child {\n  border-bottom: unset;\n}\n\n.sidebar-tab:hover {\n  opacity: 1;\n}\n\n.sidebar-tab.active{\n  opacity: 1;\n}\n\n.sidebar-tab-wallet,\n.sidebar-tab-wallet-2 {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border-bottom: 2px solid rgb(56 56 56 / 14%);\n  /* width: 80%; */\n  background-color: #fbc425;\n  margin: 0 auto;\n  padding-bottom: 16px;\n}\n\n.sidebar-tab-icon img {\n  width: 52px;\n  height: 52px;\n  cursor: pointer;\n}\n\n.sidebar-tab-wallet p {\n  font-size: 20px;\n  margin: 0px;\n  padding-top: 6px;\n  cursor: pointer;\n}\n\n.sidebar-tab-wallet-2 p {\n  font-size: 20px;\n  margin: 0px;\n  color: #fff;\n  padding-top: 6px;\n  cursor: pointer;\n}\n\n.sidebar-tab p {\n  font-size: 18px;\n  color: #fff;\n  margin: 0px;\n  padding-top: 0px;\n  cursor: pointer;\n}\n\n.sidebar-tab-icon {\n  margin-top: 10px;\n}\n\n.sidebar-wrapper {\n  margin-top: 20px;\n}\n\n.sidebar-tab-active {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border-bottom: 2px solid rgb(255 255 255 / 14%);\n  width: 80%;\n  margin: 0 auto;\n  padding-bottom: 16px;\n}\n\n.sidebar-tab-active p {\n  font-size: 20px;\n  color: #fbc425;\n  margin: 0px;\n  padding-top: 6px;\n}\n\n.sidebar-tab-logout {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* margin-top: 50px; */\n  gap: 0px;\n  opacity: 1;\n}\n\n.sidebar-tab-logout:hover{\n  opacity: 1;\n}\n\n.sidebar-tab-logout .sidebar-tab-icon {\n  margin-top: 6px;  \n}\n\n.sidebar-tab-logout p {\n  font-size: 20px;\n  color: #fff;\n  margin: 0px;\n  padding-top: 10px;\n  cursor: pointer;\n}\n\n\n.sidebar-tab button#dropdown-button-drop-end {\n  background: none;\n  border: none;\n  position: absolute;\n  top: 10px;\n  right: -90px;\n  font-size: 30px;\n  width: 160px;\n  text-align: right;\n  height: 80px;\n}\n\n.sidebar-tab .dropdown-menu.show {\n  background: #00A19B;\n  border: none;\n  border-radius: 0px;\n  opacity: 1;\n  transform: translate(105px, 0px) !important;\n  width: 230px;\n}\n\n.sidebar-tab a.dropdown-item {\n  font-size: 20px;\n  color: #fff;\n  opacity: 0.5;\n  border-bottom: 1px solid #fff;\n  border-radius: 0px;\n  padding: 10px 40px;\n}\n\n.sidebar-tab a.dropdown-item:hover{\n  opacity: 1;\n}\n\n.sidebar-tab a.dropdown-item:hover:first-child{\n  opacity: 0.5;\n}\n\n.sidebar-tab a.dropdown-item:first-child{\n  font-size: 26px;\n}\n\n.sidebar-tab a.dropdown-item:last-child{\n  border-bottom: none;\n}\n\n\n\n\n\n@media (min-width: 768px) and (max-width: 1599px) {\n  .sidebar-wrapper {\n    margin-top: 20px;\n    height: calc(100vh - 100px);\n    overflow-y: auto;\n    overflow-x: visible\n  }\n\n  .sidebar.dropdown-active .sidebar-wrapper{\n    overflow: visible;\n  }\n\n  .sidebar {\n    height: 90%;\n    width: 185px;\n    top: 70px;\n  }\n\n  .sidebar-tab-icon img {\n    width: 46px;\n    height: 46px;\n  }\n\n  .sidebar-tab p {\n    font-size: 16px;\n  }\n\n  .sidebar-tab a.dropdown-item:first-child {\n    font-size: 22px;\n  }\n\n  .sidebar-tab a.dropdown-item {\n    font-size: 18px;\n  }\n\n  .sidebar-tab .dropdown-menu.show {\n    transform: translate(99px, 0px) !important;\n    width: 200px;\n  }\n}\n\n@media (max-width: 768px) {\n  .sidebar {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
